import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AgendaMasivaModel } from "src/app/models/agendaMasiva.model";
import { GlobalService } from "src/app/shared/global.service";
import { UrlControl } from "src/app/shared/models/generic.model";
import { AlertService } from "src/app/shared/services/alert.service";
import { ConstantesService } from "src/app/shared/services/constantes.service";
import { UrlService } from "src/app/shared/services/url.service";
import { UtilService } from "src/app/shared/services/util.service";
import { UploadService } from "src/app/shared/upload.service";
import { LogInventario } from 'src/app/models/logInventario.model';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { Console } from "console";
declare var $: any;

@Component({
    selector: "app-registrar-carga-inventario",
    templateUrl: "./registrar-carga-inventario.component.html",
    styleUrls: ["./registrar-carga-inventario.component.scss"],
})
export class RegistrarCargaInventarioComponent implements OnInit {

    @ViewChild("inputFile") inputFile: ElementRef;
    @ViewChild("labelImport")
    labelImport: ElementRef;
    accept = ".xlsx, .xls";
    nombreArchivo: string;
    fileToUpload: File;
    maxSize = 102400;
    listaRegistros: ResultadoCargueInventario[] = [];
	listaMaestra: LogInventario[] = [];
    cargandoArchivo: boolean;
    sinAdjunto: string;
    tipoCargue: string;
    tituloTipoCargue: string;
    rutaPlantilla: string;
    opcSelect: string;
    rolUsuario: string;

    error: boolean;

    constructor(
        private uploadService: UploadService,
        private alertService: AlertService,
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private utilService: UtilService,
        private global: GlobalService,
        private router: Router
    ) {
        this.sinAdjunto = ConstantesService.SIN_ADJUNTO_INVENTARIO;
        this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
        this.cargandoArchivo = false;
        history.state.tipoCargue = undefined;
    }

    ngOnInit(): void {
        //throw new Error("Method not implemented.");
		this.refrescarListaCargue();
        this.setTipoCargueTitulo();
    }

    public setTipoCargueTitulo() {
        
        this.tituloTipoCargue = VariablesZonaCompartida.TITULO_TIPO_CARGUE;
        this.opcSelect=sessionStorage.getItem(ConstantesService.OPC_SELECT);
        this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
        if(this.opcSelect !== undefined && this.opcSelect !== null ){
            if( this.opcSelect === VariablesZonaCompartida.PATH_OPC_CARGA_INVENTARIO ){
                if( this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH ){
                    this.tipoCargue = VariablesZonaCompartida.PLANTA;
                    this.tituloTipoCargue += VariablesZonaCompartida.PLANTA;
                }else{
                    this.tipoCargue = VariablesZonaCompartida.ACTIVO_FIJO;
                    this.tituloTipoCargue += VariablesZonaCompartida.INVENTARIO;
                }
            }
            else
                if( this.opcSelect === "/main"+VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL ){
                    if( this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH ){
                        this.tipoCargue = VariablesZonaCompartida.PLANTA;
                        this.tituloTipoCargue += VariablesZonaCompartida.PLANTA;
                    }else{
                        this.tipoCargue = VariablesZonaCompartida.CONTRATISTA;
                        this.tituloTipoCargue += VariablesZonaCompartida.CONTRATISTA;
                    }
                }
                else
                    if( this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH ){
                        this.tipoCargue = VariablesZonaCompartida.PLANTA;
                        this.tituloTipoCargue += VariablesZonaCompartida.PLANTA;
                    }else
                        if( this.opcSelect === VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL_TERCE){
                            this.tipoCargue = VariablesZonaCompartida.TERCERO;
                            this.tituloTipoCargue += VariablesZonaCompartida.TERCERO;
                        }
        }else
            if( this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH ){
                this.tipoCargue = VariablesZonaCompartida.PLANTA;
                this.tituloTipoCargue += VariablesZonaCompartida.PLANTA;
            }else{
                this.tipoCargue = VariablesZonaCompartida.CONTRATISTA;
                this.tituloTipoCargue += VariablesZonaCompartida.CONTRATISTA;
            }
    }

	public refrescarListaCargue() {
		const serviceProvider = "LogList";
		const url = this.urlService.getUrl(
		  new UrlControl(serviceProvider, null, null),
		  this.urlService.hostAPI_CARGUE_MASIVO
		);
		this.global.getGenerico(url+`?tipo=${this.tipoCargue}`).subscribe(
		  (data) => {
			if( data.codigo == 200 ){			
				this.listaMaestra = data.contenido;
			}else{
				return this.alertService.generateAlertError(
                    "No se pudo cargar el listado de procesos",
                    "Error"
                );
			}			
		  },
		  (err) => {
			this.catchException("Error Consultando lista de cargues");
		  }
		);
		//this.subscription.push(sucripcion);
	}
    /**
     * Metodo encargado de detectar el evento del componente de carga de documentos
     */
    onFileChange(event: any) {
        this.listaRegistros = [];
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            this.fileToUpload = file;
            this.validarArchivo(this.fileToUpload);
            event.target.value = "";
        }
    }

    /**
     * Realiza las validaciones de tamaño y extencion del documento cargado
     */
    validarArchivo(archivo: File) {
        if (archivo) {
            if (!archivo.name.includes(".xls") && !archivo.name.includes(".xlsx")) {
                this.inputFile.nativeElement.value = "";
                return this.alertService.generateAlertError(
                    "No se puede cargar el archivo porque no tiene extensión: .xls ó xlsx",
                    "Error"
                );
            }
            if (archivo.size === 0) {
                this.inputFile.nativeElement.value = "";
                return this.alertService.generateAlertError(
                    "No se puede cargar el archivo porque se encuentra vacío",
                    "Error"
                );
            }
            this.uploadFiles();
        }
    }

    /**
     * Metodo encargado de realizar la carga del documento en el gestor documental
     */
    uploadFiles() {
        this.cargandoArchivo = true;
        this.nombreArchivo = this.fileToUpload.name;
        const formData = new FormData();
        formData.append("file", this.fileToUpload);
       
        return this.uploadService
            .cargarArchivoSBAsync(
                `/cargue/import?tipo=${this.tipoCargue}`,
                formData
            )
            .subscribe(
                (data) => {					
                    if (data) {						
                        this.alertService.generateAlertSuccess(data.estado, " ");
                        setTimeout(() => {
                            this.cargandoArchivo = false;
                            this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
                        }, 2000);
                    }
                },
                (error) => {
					console.log("EN ERROR");
					console.log(error);
                    this.cargandoArchivo = false;
                    this.nombreArchivo = ConstantesService.SELECCIONAR_ARCHIVO;
                    this.alertService.generateAlertError(error.error.estado, "");
                }
            );
    }

    descargarPlantilla() {
		const queryParams: Array<[string, string]> = new Array<[string, string]>();
        
        if( this.tipoCargue === VariablesZonaCompartida.ACTIVO_FIJO ){
           this.rutaPlantilla = VariablesZonaCompartida.PANTILLA_ACTIVO_FIJO;
        }else
            if(this.tipoCargue === VariablesZonaCompartida.CONTRATISTA){
                this.rutaPlantilla = VariablesZonaCompartida.PLANTILLA_CONTRATISTA;
            }else
                if( this.tipoCargue === VariablesZonaCompartida.TERCERO ){
                    this.rutaPlantilla = VariablesZonaCompartida.PLANTILLA_TERCERO;
                }else
                    if( this.tipoCargue === VariablesZonaCompartida.PLANTA ){
                        this.rutaPlantilla = VariablesZonaCompartida.PLANTILLA_PLANTA;
                    }

		queryParams.push(['name', this.rutaPlantilla]);		
        this.spinner.show();
        const serviceProvider = "descargarPlatillaMasiva";
        const url = this.urlService.getUrl(
            new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_UAC
        );
        this.global.getGenerico(url).subscribe(
            (data) => {
                this.spinner.hide();
                ConstantesService.descargarDocumento(
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    data.nombre,
              
                    data.archivo
                );
            },
            (err) => {
                if (err.status === "500") {
                    this.catchException(err.error.message);
                } else {
                    this.catchException("No se ha podido descargar el documento");
                }
            }
        );
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }

    /**
     * metodo para regresar
     */
    regresar() {
        if(this.tipoCargue === VariablesZonaCompartida.ACTIVO_FIJO){
            this.router.navigate(["main/"]);
        }else{
            this.router.navigate(["/administrar-funcionarios"]); 
        }
    }



    obtenerSombreado(errores) {
        return errores.length > 0 ? 'sombreado-tabla' : '';
    }

    mostrarErrores() {
        $('#importarArchivo').focus();
    }
}

export class InventarioMasivoDTO {

    codDep: string;
    noPlacaInventario: string;
    matriculaVehiculo: string;
    noActivoFijo: string;
    noDeSerie: string;
    clasActivoFijo: string;
    codigoMaterial: string;
    observaciones: string;
    nombreResponsable: string;
    ccResponsable: string;
    tipoVinculacion: string;
    emplazamiento: string;
    costoHistorico: string;
    errores: [];
}

export class ResultadoCargueInventario {

    errorDatos: boolean;
    inventarioMasivoDTO: InventarioMasivoDTO;

}
